<template>

    <m-edit1/>

    <m-short-link-1 v-bind='{...{},...{}}' :style='""' class="" ></m-short-link-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mShortLink1 from '@moeinmdn/miw-alpha-components/src/package/ShortLink/ShortLink1';

export default {
    name: 'HomeView',
    components: {mEdit1, mShortLink1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
